
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#0a0a0a]">
      <Header />
      <main className="flex-1 flex items-center justify-center">
        <div className="glass-panel p-12 rounded-lg max-w-md w-full text-center">
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <p className="text-xl text-gray-300 mb-8">Page not found</p>
          <Link 
            to="/" 
            className="gradient-border inline-block"
          >
            <span className="px-6 py-2 bg-black rounded-lg font-medium text-white hover:bg-opacity-80 transition-all inline-block">
              Return Home
            </span>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
